import {
  DASHBOARD_PATCH,
  DASHBOARD_RESET_BUILDER,
  DASHBOARD_CLEAR,
  DASHBOARD_ADD_WIDGET,
} from '../actionTypes/DashboardActionTypes';
import { createInitialBuilderDraft } from '../../Containers/DashboardNewContainer/reportBuilder/constants/initialBuilderDraft';
import { EMPTY_REPORT_ADD_MODAL } from '../../Containers/DashboardNewContainer/reportBuilder/constants/reportAddModal';
import { EMPTY_DASHBOARD_CONFIRM_MODAL } from '../../Containers/DashboardNewContainer/constants/dashboardConfirmModal';
import { EMPTY_REPORT_VIEW_MORE_MODAL } from '../../Containers/DashboardNewContainer/reportViewMore/constants/reportViewMoreModal';
import { DEFAULT_TEMPLATE_CHOOSER_ID } from '../../Containers/DashboardNewContainer/widget/definitions';
import { normalizeWidget } from '../../Containers/DashboardNewContainer/widget/definitions/widgetUtils';

const EMPTY_BOOTSTRAP = { loading: false, error: null, data: null };

export const dashboardInitialState = {
  isDashboardEmpty: true,
  homeData: null,
  homeLoading: false,
  homeError: null,
  searchKeyword: '',
  searchResults: null,
  searchLoading: false,
  searchError: null,
  homeFilter: 'all',
  contexts: [],
  selectedContextId: '',
  contextsLoading: false,
  activeDashboardId: null,
  activeDashboard: null,
  starPending: false,
  isWidgetChooserOpen: false,
  widgetChooserMode: 'template',
  chooserSelectedPresetId: DEFAULT_TEMPLATE_CHOOSER_ID,
  dashboardMode: null,
  dashboardTemplateId: null,
  dashboardWidgets: [],
  reportRefreshTokens: {},
  pendingReportPreset: null,
  isReportBuilderOpen: false,
  reportBuilderBootstrap: { ...EMPTY_BOOTSTRAP },
  activeStep: 1,
  builderDraft: createInitialBuilderDraft(),
  stepValidationError: '',
  reportBuilderSubmitting: false,
  reportAddModal: { ...EMPTY_REPORT_ADD_MODAL },
  reportViewMoreModal: { ...EMPTY_REPORT_VIEW_MORE_MODAL },
  dashboardConfirmModal: { ...EMPTY_DASHBOARD_CONFIRM_MODAL },
  isPreviewMode: true,
  savePending: false,
  isCreateDashboardOpen: false,
  dashboardFormMode: 'create',
  editingDashboard: null,
  createPending: false,
};

const DashboardReducer = (state = dashboardInitialState, action) => {
  switch (action.type) {
    case DASHBOARD_PATCH:
      return { ...state, ...action.payload };

    case DASHBOARD_RESET_BUILDER:
      return {
        ...state,
        isDashboardEmpty: true,
        dashboardMode: null,
        dashboardTemplateId: null,
        dashboardWidgets: [],
        activeDashboardId: null,
        activeDashboard: null,
        isWidgetChooserOpen: false,
        isCreateDashboardOpen: false,
        dashboardFormMode: 'create',
        editingDashboard: null,
        pendingReportPreset: null,
        isPreviewMode: true,
      };

    case DASHBOARD_ADD_WIDGET:
      return {
        ...state,
        isWidgetChooserOpen: false,
        isDashboardEmpty: false,
        dashboardMode: state.dashboardMode || 'custom',
        dashboardWidgets: [
          ...state.dashboardWidgets,
          ...action.payload.widgets.map(normalizeWidget),
        ],
      };

    case DASHBOARD_CLEAR:
      return { ...dashboardInitialState, builderDraft: createInitialBuilderDraft() };

    default:
      return state;
  }
};

export default DashboardReducer;
